module.exports = __webpack_public_path__ + "img/level1_mining_tool-1.8018c20e.png";